<template>
  <div class="wrapper">
    <div class="list_content" loadmoreoffset="10">
      <div>
        <div class>
          <div class="list_box">
            <div class="keyBox">
              <span class="list_key">姓名</span>
              <span class="red">*</span>
            </div>
            <span class="list_val_text" v-if="name">{{name}}</span>
            <input
              class="list_val"
              v-else
              v-model="params.userName"
              maxlength="20"
              type="text"
              placeholder="请输入真实姓名"
            />
          </div>
          <div class="list_box">
            <div class="keyBox">
              <span class="list_key">手机</span>
              <span class="red">*</span>
            </div>
            <span class="list_val_text">{{params.phone}}</span>
          </div>
          <div class="list_box">
            <div class="keyBox">
              <span class="list_key">邮箱</span>
            </div>
            <input class="list_val" v-model="params.email" type="email" placeholder="请输入电子邮箱" />
          </div>
        </div>
      </div>
      <div>
        <div class="cell_box">
          <div class="list_box">
            <div class="keyBox">
              <span class="list_key">项目</span>
              <span class="red">*</span>
            </div>
            <span class="list_val_text">{{marketName}}</span>
          </div>
          <div class="list_box" @click="selectCompany">
            <div class="keyBox">
              <span class="list_key">公司</span>
              <span class="red">*</span>
            </div>
            <span :class="['list_val','list_val_span',params.company=='请选择公司'?'list_pla':'']">{{params.company}}</span>
            <img class="list_arror" src="../../assets/images/icon_indicator_next.png" />
          </div>
          <!-- <div class="list_box" @click="select(sysOrgs,'bumen')" v-if="params.companyId">
            <div class="keyBox">
              <span class="list_key">部门</span>
            </div>
            <span
              class="list_val list_val_span"
              v-if="params.department && params.department != '请选择部门'"
            >{{params.department}}</span>
            <span class="list_val list_val_span list_pla" v-else>请选择部门</span>
            <img class="list_arror" src="../../assets/images/icon_indicator_next.png" />
          </div>
          <div class="list_box" v-if="params.department=='增加新的部门'">
            <span class="list_key"></span>
            <input class="list_val" v-model="department" type="text" placeholder="请输入其它部门名称" />
          </div> -->
          <div class="list_box" @click="select(floorArr,'louceng')" v-if="params.companyId && floorArr.length > 0">
            <div class="keyBox">
              <span class="list_key">楼层</span>
              <span :class="['red','white']">*</span>
            </div>
            <span :class="['list_val','list_val_span',!floorArr[idenIdxLc]?'list_pla':'']">{{floorArr[idenIdxLc]}}</span>
            <img class="list_arror" src="../../assets/images/icon_indicator_next.png" />
          </div>
        </div>
      </div>
    </div>
    <mt-popup v-model="popupVisible" position="bottom" class="popupBox">
      <mt-picker
        class="picker"
        :slots="dataList"
        @change="onValuesChange"
        :visible-item-count="5"
        :show-toolbar="true"
        :item-height="44"
        ref="picker"
      >
        <div class="picker_wrap">
          <div class="picker_btn" @click="popupVisible=false">取消</div>
          <div class="picker_btn2" @click="handleConfirm">确认</div>
        </div>
      </mt-picker>
    </mt-popup>
    <div class="footer_box button">
      <mt-button class="p btn_default" @click="submit">提交认证</mt-button>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import {
  queryCompanyTenant,
  getDeptByCompanyId,
  userTenant
} from "../../utils/api";
import util from "../../utils/util";
import storage from "../../utils/storage";
import { parse } from 'path';

export default {
  data() {
    return {
      isclick: false,
      name: "",
      isToAddPhone:false,
      marketName: "",
      newDepartment: "",
      popupVisible: false,
      params: {
        company: "请选择公司",
        companyId: "",
        department: "请选择部门",
        departmentId: "",
        userName: "",
        userId: "",
        email: "",
        phone: "",
        marketId: "",
        isDeafult: "0",
        defaultBuild: "", //楼栋
        defaultFloor: "" //楼层
      },
      bumen: [
        {
          flex: 1,
          values: [],
          className: "slot1",
          textAlign: "center"
        }
      ],
      dataList: [],
      dataType: "",
      sysOrgs: [], //部门
      sysOrgsId: [], //部门id
      idenIdx: -1,
      idenIdxLc: 0,
      department: "", //手动输入部门
      floorArr: [], //楼层
      ldArr:[],
      lcArr:[]
    };
  },
  components: {},
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  created() {
    storage.remove("companyData");
    if(this.common.userTenantInfo){
      this.params.userName = this.common.userTenantInfo.userName || '';
      this.name = this.common.userTenantInfo.userName || '';
    }
    this.params.userId = this.common.userId || "";
    this.params.phone = this.common.userInfo.phone || this.common.userInfo.account || "";
    this.params.email = this.common.userInfo.email || "";
    this.params.marketId = this.common.marketInfo.id || "";
    this.marketName = this.common.marketInfo.marketName;
    if(this.$route.query.isToAddPhone){
      this.isToAddPhone = this.$route.query.isToAddPhone.toString();
    }
  },
  activated() {
    if (storage.get("companyData")) {
      let companyData = JSON.parse(storage.get("companyData"));
      this.params.company = companyData.companyName;
      this.params.companyId = companyData.id;
      this.getDeptByCompanyId(); // 根据公司获取部门数据
      this.queryCompanyTenant(); // 根据公司获取楼层数据
    }
  },
  destroyed() {
    console.log("destroyed");
    storage.remove("companyData");
  },
  methods: {
    onValuesChange(picker, values) {
      if (values[0] > values[1]) {
        picker.setSlotValue(1, values[0]);
      }
    },
    handleConfirm() {
      this.popupVisible = false;
      if (this.dataType == "bumen") {
        this.params.department = this.$refs.picker.getValues()[0];
        this.sysOrgs.forEach((item, index) => {
          if (item == this.params.department) {
            this.params.departmentId = this.sysOrgsId[index];
          }
        });
      } else if (this.dataType == "louceng") {
        let dd = this.$refs.picker.getValues()[0];
        this.floorArr.forEach((item, index) => {
          if (item == dd) {
            this.params.defaultBuild = this.ldArr[index];
            this.params.defaultFloor = this.lcArr[index];
            this.idenIdxLc = index;
          }
        });
      }
    },
    select(data, type) {
      this.popupVisible = true;
      this.bumen[0].values = data;
      this.dataList = this.bumen;
      this.dataType = type;
      console.log(this.dataList);
    },
    queryCompanyTenant() {
      let params = {
        marketId: this.params.marketId,
        companyId: this.params.companyId,
        visitorMode: "0",
        userId: ""
      };
      queryCompanyTenant(params).then(res => {
        console.log(res);
        if (res.res.code == "10000" && res.body.companyList) {
          let data = res.body.companyList[0].buildData || [],
            floorArr = [],
            ldArr = [],
            lcArr = [];
          if (data.length > 0) {
            data.forEach(item => {
              floorArr.push(item.ld+'_'+item.lc);
              ldArr.push(item.ld);
              lcArr.push(item.lc);
            });
            this.params.defaultBuild = ldArr[0];
            this.params.defaultFloor = lcArr[0];
            this.floorArr = floorArr;
            this.ldArr = ldArr;
            this.lcArr = lcArr;
          }
        }
      });
    },
    // 根据公司获取部门数据
    getDeptByCompanyId() {
      let that = this;
      let params = {
        companyId: that.params.companyId
      };
      getDeptByCompanyId(params).then(res => {
        console.log(res);
        if (res.res && res.res.code == "10000") {
          let arr = [],
            arrId = [];
          if (res.body.sysOrgs.length > 0) {
            for (let i = 0; i < res.body.sysOrgs.length; i++) {
              arr.push(res.body.sysOrgs[i].name);
              arrId.push(res.body.sysOrgs[i].id);
            }
            // that.params.department = res.body.sysOrgs[0].name;
            // that.params.departmentId = res.body.sysOrgs[0].id;
            arr.push("增加新的部门");
            arrId.push("");
            that.sysOrgs = arr;
            that.sysOrgsId = arrId;
            that.idenIdx = 0;
          } else {
            that.params.department = "";
            that.params.departmentId = "";
            that.sysOrgs = ["增加新的部门"];
            that.idenIdx = 0;
          }
        } else {
          util.showToast(res.res.msg);
        }
      });
    },
    bindinput(e) {
      let type = e.currentTarget.dataset.type;
      this.params[type] = e.detail.value;
    },
    submit() {
      let params = this.params;
      if (!params.userName) {
        util.showToast("请输入姓名");
        return;
      } else if (/[^\w\u4e00-\u9fa5]/g.test(params.userName)) {
        util.showToast("用户名不能有特殊字符");
        return;
      }
      if (!params.phone && params.phone.length != 11) {
        util.showToast("请输入正确的手机号");
        return;
      }
      if (params.email) {
        var reg = new RegExp(
          "^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$"
        );
        if (!reg.test(params.email.toLowerCase())) {
          //正则验证不通过，格式不对
          util.showToast("请输入正确的邮箱地址");
          return;
        }
      }
      if (!params.company || params.company == "请选择公司") {
        util.showToast("请选择公司");
        return;
      }

      if (params.department == "增加新的部门" && !this.department) {
        util.showToast("请输入部门名称");
        return;
      }
      if (params.department == "增加新的部门") {
        params.department = this.department;
        params.departmentId = "";
      }
      if(params.department == "请选择部门"){
        params.department = '';
        params.departmentId = "";
      }
      util.showLoading("提交中…");
      console.log(this.params);
      var that =this;
      userTenant(this.params).then(res => {
        util.hideLoading();
        if (res.res && res.res.code == "10000") {
          util.showToast("提交成功!");
           //this.$router.go(-1);
            if(that.isToAddPhone =='true'){
                 setTimeout(() => {
                    that.toAddphone();
                 }, 1000);
            }else{
                setTimeout(() => {
                    that.$router.go(-1);
                }, 1000);
            }
        } else {
          util.showToast(res.res.msg);
        }
      });
    },
    toAddphone(){
      this.$router.replace({
         path:'/addPhoto'
      });
    },
    // 跳转选择公司
    selectCompany() {
      this.$router.push({
        path: `/companySelect`
      });
    },
    selectDepartment(e) {
      let that = this;
      console.log(that.params.companyId);
      if (!that.params.companyId) {
        util.showToast("请先选择公司");
        return;
      }
    },
    bindIdtPickerChange(e) {
      let that = this;

      that.params.department = that.sysOrgs[e.detail.value];
      that.params.departmentId = that.sysOrgsId[e.detail.value];

      if (that.params.department == "增加新的部门") {
        that.params.department = "";
      }
      this.idenIdx = e.detail.value;
    },
    bindIdtPickerChangeLc(e) {
      let that = this;
      that.params.defaultBuild = that.ldArr[e.detail.value];
      that.params.defaultFloor = that.lcArr[e.detail.value];
      this.idenIdxLc = e.detail.value;
    }
  }
};
</script>
<style scoped lang="less">
@import "../../assets/css/common.less";
.popupBox {
  width: 100%;
}
.wrapper {
  background-color: #f3f4f6;
}
.list_content {
  background-color: #f3f4f6;
  margin-bottom: 108px;
  overflow: hidden;
}
.cell_box {
  margin-top: 14px;
}
.list_box {
  .flex();
  height:100px;
  align-items:center;
  .borderB();
  padding-left: 30px;
  padding-right: 66px;
  position: relative;
  background-color: #fff;
}

.keyBox {
  flex-direction: row;
  min-width:120px;
}

.list_key {
  font-size: 28px;
  color: #666;
  height: 100px;
  line-height: 100px;
}

.red {
  height: 100px;
  line-height: 100px;
  color: red;
}
.white {
  color: #ffffff;
}
.list_arror {
  position: absolute;
  right: 30px;
  top: 34px;
  width: 32px;
  height: 32px;
  z-index: 2;
}

.user_photo {
  margin-top: 27px;
}

.list_val {
  // width: 470px;
  flex:1;
  height: 98px;
  text-align: left;
  font-size: 28px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.list_val_span{
  line-height:100px;
}
.list_val_text {
  // width: 470px;
  flex:1;
  height: 98px;
  line-height: 100px;
  text-align: left;
  font-size: 28px;
  color: #999999;
}

.list_pla {
  color: #c9c9c9;
}

.footer_box {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 108px;
  background: #f3f4f6;
  padding: 16px 28px;
  z-index: 100;
  box-sizing: border-box;
  .p {
    height: 76px;
    width: 100%;
    background: @color17;
    border-radius: 4px;
    text-align: center;
    line-height: 76px;
    color: #fff;
    font-size: 32px;
  }
}
.picker {
  width: 100%;
}
.picker_wrap {
  height: 100px;
  display: flex;
  justify-content: space-between;
  padding: 0 28px;
  box-sizing: border-box;
}
.picker_btn,
.picker_btn2 {
  flex: 1;
  .fontSize(16px);
  text-align: left;
  line-height: 100px;
}
.picker_btn2 {
  text-align: right;
  color: @color17;
}
</style>
